import React from "react";
import { Image } from "react-bootstrap";

/**
 * Render an HTML object to display image. 
 * @param imageUrl : url of image
 * @param className: classname of HTML field displayed
 * @param {} param0 
 */
export default function NeoImage({ imageUrl, className }) {

    if (!imageUrl) {
        return null;
    };

    return (
        <div className={className}>
            <Image className={className} src={imageUrl} />
        </div>
    );
}